import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  MealPlan,
  MealPlanData,
  TemplatePlan,
} from 'app/@core/interfaces/common/CalorieFriend/plan';

@Injectable()
export class MealPlanTemplateResolver implements Resolve<Observable<any>> {
  constructor(private planService: MealPlanData) {}

  resolve(route: ActivatedRouteSnapshot) {
    return forkJoin([
      route.params.id
        ? this.planService.GetTemplateById(route.params.id)
        : of(this.getEmptyTemplate()),
    ]).pipe(map(([template]) => ({ template })));
  }

  private getEmptyTemplate(): TemplatePlan<MealPlan> {
    return {
      id: 0,
      name: '',
      description: '',
      thePlan: null,
      isPublic: false,
    };
  }
}
